(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["alva-care-tiles"] && !Shopify.designMode) return;
  try {
    (() => {
  const mobile = window.matchMedia('(max-width:749px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function init(root = document) {
    root.querySelectorAll('.alva-care-routine__group').forEach(group => {
      const track = group.querySelector('.alva-care-routine__steps');
      const controls = group.querySelector('.alva-care-routine__controls');
      if (!track || !controls || track.dataset.careReady === 'true') return;
      const cards = Array.from(track.children);
      const previous = controls.querySelector('[data-care-previous]');
      const next = controls.querySelector('[data-care-next]');
      const position = controls.querySelector('[data-care-position]');
      let drag = null;
      let index = 0;
      const clamp = value => Math.max(0, Math.min(cards.length - 1, value));
      const stride = () => cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth;
      function update() {
        const width = stride();
        if (width > 0) index = clamp(Math.round(track.scrollLeft / width));
        previous.disabled = index === 0;
        next.disabled = index === cards.length - 1;
        position.textContent = `${String(index + 1).padStart(2, '0')} / ${String(cards.length).padStart(2, '0')}`;
      }
      function go(target, smooth = true) {
        index = clamp(target);
        track.scrollTo({ left: index * stride(), behavior: smooth && !reducedMotion.matches ? 'smooth' : 'auto' });
        previous.disabled = index === 0;
        next.disabled = index === cards.length - 1;
        position.textContent = `${String(index + 1).padStart(2, '0')} / ${String(cards.length).padStart(2, '0')}`;
      }
      track.addEventListener('pointerdown', event => {
        if (!mobile.matches || event.isPrimary === false || event.button > 0 || track.scrollWidth <= track.clientWidth + 1) return;
        if (event.target.closest('a,button,input,select,textarea')) return;
        drag = { id: event.pointerId, x: event.clientX, y: event.clientY, lastX: event.clientX, left: track.scrollLeft, index, active: false };
        if (event.pointerType === 'mouse') event.preventDefault();
      });
      track.addEventListener('pointermove', event => {
        if (!drag || event.pointerId !== drag.id) return;
        const dx = event.clientX - drag.x;
        const dy = event.clientY - drag.y;
        drag.lastX = event.clientX;
        if (!drag.active) {
          if (Math.abs(dx) < 8 || Math.abs(dx) <= Math.abs(dy)) return;
          drag.active = true;
          track.style.scrollSnapType = 'none';
          track.classList.add('is-dragging');
          track.setPointerCapture(event.pointerId);
        }
        if (event.cancelable) event.preventDefault();
        track.scrollLeft = drag.left - dx;
      }, { passive: false });
      function finish(event) {
        if (!drag || event.pointerId !== drag.id) return;
        const gesture = drag;
        drag = null;
        track.classList.remove('is-dragging');
        track.style.scrollSnapType = '';
        if (track.hasPointerCapture(gesture.id)) track.releasePointerCapture(gesture.id);
        if (!gesture.active) return;
        const dx = gesture.lastX - gesture.x;
        const threshold = Math.min(40, track.clientWidth * .15);
        go(gesture.index + (dx < -threshold ? 1 : dx > threshold ? -1 : 0));
      }
      track.addEventListener('pointerup', finish);
      track.addEventListener('pointercancel', finish);
      track.addEventListener('lostpointercapture', finish);
      track.addEventListener('scroll', () => { if (!drag) update(); }, { passive: true });
      track.addEventListener('keydown', event => {
        if (!mobile.matches) return;
        const target = { ArrowLeft: index - 1, ArrowRight: index + 1, Home: 0, End: cards.length - 1 }[event.key];
        if (target === undefined) return;
        event.preventDefault();
        go(target);
      });
      previous.addEventListener('click', () => go(index - 1));
      next.addEventListener('click', () => go(index + 1));
      mobile.addEventListener('change', () => go(0, false));
      new ResizeObserver(() => { if (mobile.matches && !drag) go(index, false); }).observe(track);
      track.dataset.careReady = 'true';
      controls.hidden = false;
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alva-confidence-modal"] && !Shopify.designMode) return;
  try {
    if (!window.__alvaConfidenceBackdropDismiss) {
    window.__alvaConfidenceBackdropDismiss = true;
    document.addEventListener('click', event => {
      const dialog = event.target instanceof HTMLDialogElement ? event.target : null;
      if (!dialog || !dialog.matches('[data-alva-confidence-dialog]') || !dialog.open) return;
      const bounds = dialog.getBoundingClientRect();
      const isOutside = event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom;
      if (isOutside) dialog.close();
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alva-cookware-comparison"] && !Shopify.designMode) return;
  try {
    function updatePanChart(chart) {
  const size = chart.dataset.panSize;
  const headers = [...chart.querySelectorAll('thead th')].filter(header => header.querySelector('[data-pan-options]'));
  const matches = headers.map(header => [...header.querySelector('template').content.children].find(option => option.dataset.size === size));
  const matched = headers.filter(header => header.offsetWidth).every(header => matches[headers.indexOf(header)]);
  headers.forEach((header, index) => {
    const price = header.querySelector('.alva-compare__price');
    price.dataset.starting ||= price.textContent;
    price.textContent = matched && matches[index] ? matches[index].textContent : price.dataset.starting;
  });
  const basis = chart.querySelector('.alva-pan-basis');
  basis.hidden = !matched;
  basis.textContent = matched ? 'Comparing ' + size.replace('-inch', '″') + ' pans' : '';
}
function refreshPanCharts(){document.querySelectorAll('[data-pan-chart]').forEach(updatePanChart)}
refreshPanCharts();
document.addEventListener('DOMContentLoaded', refreshPanCharts);
document.addEventListener('shopify:section:load', refreshPanCharts);
window.matchMedia('(max-width:749px)').addEventListener('change',refreshPanCharts);
document.addEventListener('change',event=>{const chart=event.target.closest('[data-pan-chart]');if(chart)updatePanChart(chart)});
document.addEventListener('variant:change',event=>{
  const variant=event.detail?.variant;
  if(!variant)return;
  document.querySelectorAll('[data-pan-chart]').forEach(chart=>{
    if(String(variant.product_id)===chart.dataset.panChart || (event.detail.formId || '').includes(chart.dataset.panChart)){
      chart.dataset.panSize=variant.title;
      updatePanChart(chart);
    }
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alva-cookware-quiz"] && !Shopify.designMode) return;
  try {
    (() => {
  function rankProducts(products,a) {
    const cap=a.budget==='any'?Infinity:Number(a.budget), items=[];
    products.forEach(p=>p.variants.forEach(v=>{
      const kind=p.kind==='single'&&/set/i.test(v.title)?'starter':p.kind;
      if(kind!==a.format || v.price>cap) return;
      if(a.stove==='induction'&&!p.induction || Number(a.oven)>p.oven) return;
      if(a.priority==='release'&&p.material!=='ceramic') return;
      if(a.priority==='sear'&&!['stainless','carbon'].includes(p.material)) return;
      if(p.material==='carbon'&&a.season!=='yes') return;
      if(a.priority==='light'&&p.material==='cast') return;
      if(a.food==='slow'&&kind==='single'&&p.material!=='cast') return;
      if(a.food!=='slow'&&kind==='single'&&p.material==='cast') return;
      const size=kind==='single'&&p.material!=='cast'?parseFloat(v.title):0;
      if(kind==='single'&&p.material!=='cast'&&!size) return;
      const target={1:8,2:9.5,4:11,6:12.6}[a.people]||9.5;
      if(size&&a.people==='4'&&size<11 || size&&a.people==='6'&&size<11) return;
      const foodScores={eggs:{ceramic:35,stainless:4,carbon:8,cast:0},meat:{stainless:35,carbon:25,ceramic:12,cast:8},sear:{carbon:35,stainless:32,ceramic:0,cast:10},slow:{cast:40,stainless:20,ceramic:10,carbon:0},mixed:{stainless:26,ceramic:26,carbon:14,cast:8}};
      let score=(foodScores[a.food]||{})[p.material]||0;
      if(a.priority==='light'&&p.line==='energy')score+=70;
      if(a.priority==='space'&&p.line==='neat')score+=70;
      if(size)score+=Math.max(0,40-Math.abs(size-target)*18);
      if(p.line==='maestro')score+=3;
      items.push({product:p,variant:v,kind,size,score});
    }));
    items.sort((x,y)=>y.score-x.score||x.variant.price-y.variant.price);
    const seen=new Set();return items.filter(i=>!seen.has(i.product.id)&&seen.add(i.product.id));
  }
  function init(root) {
    if(!root||root.dataset.ready)return;root.dataset.ready='true';
    const data=JSON.parse(root.querySelector('[data-finder-data]').textContent),c=Object.assign(data.copy,...data.extra.map(value=>JSON.parse(value)));
    const panel=root.querySelector('[data-finder-panel]'),stage=root.querySelector('[data-finder-stage]'),progress=root.querySelector('[data-finder-progress]'),bar=root.querySelector('[data-finder-bar]');
    let a={},index=0,editing=false;
    const keys=['format','food','priority','kitchen','budget'];
    const codes={format:['single','starter','full'],food:['eggs','meat','sear','slow','mixed'],priority:['release','sear','light','space']};
    const copyKeys={format:'q3',food:'q0',priority:'q1'};
    const esc=v=>String(v??'').replace(/[&<>"']/g,k=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[k]));
    const money=n=>new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:data.currency||'USD',maximumFractionDigits:0}).format(n/100);
    const label=(key,value)=>key==='budget'?(value==='any'?c.q4_any:c.budget_up_to+' '+money(Number(value))):c[copyKeys[key]+'_'+codes[key].indexOf(value)];
    const link=(url,text)=>'<a class="af-text-link" href="'+esc(url)+'">'+esc(text)+'</a>';
    const url=i=>i.product.url+'?variant='+encodeURIComponent(i.variant.id);
    const track=(event,extra={})=>{if(window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()){window.dataLayer=window.dataLayer||[];window.dataLayer.push({event,finder_version:'2026-10-14',...extra});}};
    const focus=()=>{const h=stage.querySelector('h2');if(h){h.tabIndex=-1;h.focus({preventScroll:true});}};
    const scroll=()=>panel.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
    function options(key){
      if(key==='budget')return (a.format==='single'?[10000,15000,25000]:a.format==='starter'?[20000,30000,50000]:[30000,50000,80000]).map(value=>({value:String(value),label:c.budget_up_to+' '+money(value)})).concat([{value:'any',label:c.q4_any}]);
      return codes[key].map(value=>({value,label:label(key,value)}));
    }
    const warrantyYears=p=>({energy:5,cicla:3,neat:10,forest:10,artist:25,nori:25,stainless:25,maestro:10,ceramic:10}[p.line]);
    const needsSeason=()=>a.priority==='sear'||a.food==='sear';
    function revealKitchen(){
      const form=stage.querySelector('[data-finder-kitchen]');if(!form)return;
      let ready=true;
      form.querySelectorAll('select').forEach(field=>{
        field.closest('label').hidden=!ready;field.disabled=!ready;
        if(!field.value)ready=false;
      });
      form.querySelector('button[type="submit"]').hidden=!ready;
    }
    function kitchenComplete(){return(a.format!=='single'||a.people)&&a.stove&&a.oven&&(!needsSeason()||a.season);}
    function select(name,title,opts){return '<label>'+esc(title)+'<select required name="'+name+'"><option value="">'+esc(c.select)+'</option>'+opts.map(([value,text])=>'<option value="'+value+'"'+(a[name]===value?' selected':'')+'>'+esc(text)+'</option>').join('')+'</select></label>';}
    function renderQuestion(){
      const key=keys[index];root.classList.add('is-active');panel.hidden=false;
      progress.textContent=c.progress.replace('{current}',index+1);bar.style.width=index*20+'%';bar.parentElement.setAttribute('aria-valuenow',index*20);
      let title=key==='kitchen'?c.kitchen:key==='budget'?c.q4:key==='priority'?c.priority_heading:c[copyKeys[key]];
      let hint=key==='kitchen'?c.kitchen_hint:key==='budget'?(a.format==='single'?c.budget_hint_single:c.budget_hint_set):key==='priority'?c.priority_hint:c[key==='format'?'h3':'h0'];
      let body='';
      if(key==='kitchen'){
        body='<form data-finder-kitchen><div class="af-kitchen">';
        if(a.format==='single')body+=select('people',c.household,[['1',c.people_1],['2',c.people_2],['4',c.people_4],['6',c.people_6]]);
        body+=select('stove',c.stove,[['gas',c.stove_gas],['electric',c.stove_electric],['induction',c.stove_induction],['unknown',c.stove_unknown]]);
        body+=select('oven',c.oven,[['0',c.oven_no],['400',c.oven_400],['500',c.oven_500]]);
        if(needsSeason())body+=select('season',c.season,[['no',c.season_no],['yes',c.season_yes]]);
        body+='</div><button class="af-button" type="submit">'+esc(c.next)+'</button></form>';
      }else{
        body='<div class="af-options">'+options(key).map(o=>{
          const mat={eggs:'ceramic',meat:'stainless',sear:'carbon',slow:'cast'}[o.value];
          const source=key==='food'&&mat?root.querySelector('.af-style__image[href*="'+({ceramic:'nonstick',stainless:'stainless-steel',carbon:'carbon-steel',cast:'cast-iron'}[mat])+'"] img'):null;
          return '<button type="button" class="af-option" aria-pressed="'+(a[key]===o.value)+'" data-finder-answer="'+esc(o.value)+'">'+(source?'<img src="'+esc(source.currentSrc||source.src)+'" width="64" height="64" alt="" loading="lazy">':'')+'<span>'+esc(o.label)+'</span></button>';
        }).join('')+'</div>';
      }
      stage.innerHTML='<div class="af-question"><h2>'+esc(title)+'</h2><p>'+esc(hint)+'</p>'+body+(index?'<button class="af-text-link" type="button" data-finder-back>← '+esc(c.back)+'</button>':'')+'</div>';
      if(key==='kitchen')revealKitchen();
      focus();
    }
    function chips(){
      const values=['format','food','priority','budget'].filter(k=>a[k]).map(k=>({key:k,text:label(k,a[k])}));
      if(a.stove)values.splice(3,0,{key:'kitchen',text:[a.format==='single'?c['people_'+a.people]:'',c['stove_'+a.stove],a.oven==='0'?c.oven_no:c['oven_'+a.oven]].filter(Boolean).join(' · ')});
      return '<p class="af-selected-label">'+esc(c.edit_hint)+'</p><ul class="af-selected">'+values.map(v=>'<li><button type="button" data-finder-edit="'+v.key+'" aria-label="'+esc(c.edit_aria.replace('{answer}',v.text))+'">'+esc(v.text)+'</button></li>').join('')+'</ul>';
    }
    function renderResult(){
      index=5;editing=false;progress.textContent=c.result_progress;bar.style.width='100%';bar.parentElement.setAttribute('aria-valuenow','100');
      const matches=rankProducts(data.products,a),best=matches[0];
      if(!best){
        const suggestions=[
          {key:'budget',test:{budget:'any'},text:'Try a higher budget'},
          {key:'priority',test:{priority:'flexible'},text:'Review your top priority'},
          {key:'kitchen',test:{oven:'0',stove:'gas',people:'1',season:'yes'},text:'Review cooktop, oven or size needs'},
          {key:'format',test:{format:a.format==='single'?'full':'single'},text:'Consider a different set or single piece'}
        ].filter(option=>rankProducts(data.products,{...a,...option.test}).length);
        const conflict=a.format==='single'&&a.food==='slow'&&a.priority==='release'
          ? 'Our current single-pot recommendations for slow cooking are enameled cast iron, which is not a ceramic nonstick surface. Review your priority or consider a cookware set.'
          : 'Your selected budget, cooking needs and available products do not currently overlap. You can change an answer below; we will keep your requirements until you choose to change them.';
        stage.innerHTML='<h2>'+esc(c.empty_title)+'</h2><p>'+esc(conflict)+'</p><div class="af-question-actions">'+suggestions.map(option=>'<button type="button" class="af-button af-button--outline" data-finder-edit="'+option.key+'">'+esc(option.text)+'</button>').join('')+'</div>'+chips()+link('/collections/cookware-collection',c.compare);track('cookware_finder_no_match',{shopping_format:a.format,budget:a.budget});focus();scroll();return;}
      const p=best.product,v=best.variant;
      let alt=matches.slice(1).find(i=>i.variant.price<v.price)||matches[1];
      const altLabel=alt?(alt.variant.price<v.price?c.alt_price:alt.product.line==='energy'?c.alt_light:alt.product.line==='neat'?c.alt_space:alt.product.material!==p.material?c.alt_material:c.alt_premium):'';
      const reasons=[];
      if(a.priority==='release')reasons.push(c.priority_ceramic);
      else if(a.priority==='sear')reasons.push(c['priority_'+p.material]);
      else if(a.priority==='light'&&p.line==='energy')reasons.push(c.priority_energy);
      else if(a.priority==='space'&&p.line==='neat')reasons.push(c.priority_neat);
      else reasons.push(c['food_'+p.material]);
      if(best.size)reasons.push(c['size_'+a.people]);else reasons.push(c['fits_format_'+best.kind]);
      if(a.stove==='induction')reasons.push(c.induction_fit);else if(Number(a.oven)>0)reasons.push(c.oven_fit);else if(a.budget!=='any')reasons.push(c.budget_fit);else reasons.push(c['food_'+p.material]);
      const uniqueReasons=[...new Set(reasons)];
      const care=c[p.line==='forest'?'care_forest':p.line==='artist'?'care_artist':p.line==='energy'?'care_energy':'care_'+p.material];
      const warnings=[];
      if(a.priority==='light'&&p.line!=='energy')warnings.push(c.soft_light);
      if(a.priority==='space'&&p.line!=='neat')warnings.push(c.soft_space);
      if(a.food==='eggs'&&p.material!=='ceramic'||a.food==='sear'&&p.material==='ceramic')warnings.push(c.soft_food);
      stage.innerHTML='<header class="af-result-head"><p class="af-eyebrow">'+esc(c.best)+'</p><h2>'+esc(c.result_title)+'</h2></header>'+warnings.map(t=>'<p class="af-warning">'+esc(t)+'</p>').join('')+'<div class="af-match"><a class="af-match__image" data-finder-product="primary" href="'+esc(url(best))+'"><img src="'+esc(v.image||p.image)+'" alt="'+esc(p.title)+'" width="720" height="720"></a><div class="af-match__copy"><p class="af-material">'+esc(c[p.material+'_name'])+'</p><h3>'+esc(p.title)+'</h3><div class="af-rating" data-finder-result-rating></div>'+(v.title!=='Default Title'?'<p class="af-match__variant">'+esc(c.size)+': '+esc(v.title)+'</p>':'')+'<p class="af-price">'+esc(v.money)+'</p><div class="af-match__reasons"><p><strong>'+esc(c.why)+'</strong></p><ul>'+uniqueReasons.map(t=>'<li>'+esc(t)+'</li>').join('')+'</ul></div><p class="af-care"><strong>'+esc(c.care)+'</strong> '+esc(care)+'</p><a class="af-button" data-finder-product="primary" href="'+esc(url(best))+'">'+esc(c.shop)+' →</a><div class="af-result-links">'+link('/pages/shipping-returns',c.trial)+(warrantyYears(p)?link('/pages/warranty',warrantyYears(p)+'-year limited warranty'):'')+'</div></div></div><details class="af-edit-answers"><summary>'+esc(c.edit)+'</summary>'+chips()+'</details>'+(alt?'<article class="af-alternative"><a data-finder-product="alternative" href="'+esc(url(alt))+'"><img src="'+esc(alt.variant.image||alt.product.image)+'" alt="'+esc(alt.product.title)+'" width="120" height="120" loading="lazy"></a><div><p class="af-eyebrow">'+esc(altLabel)+'</p><h3>'+esc(alt.product.title)+'</h3><p>'+esc(alt.variant.title==='Default Title'?'':alt.variant.title+' · ')+esc(alt.variant.money)+'</p>'+link(url(alt),c.alternative_shop)+'</div></article>':'')+'<p class="af-result-note">'+esc(c.result_note)+'</p><div class="af-result-bottom">'+link('/pages/compare-collections',c.compare)+'<button class="af-text-link" data-finder-browse type="button">'+esc(c.browse_again)+'</button></div>';
      const rating=root.querySelector('template[data-finder-rating="'+p.id+'"]');if(rating)stage.querySelector('[data-finder-result-rating]').append(rating.content.cloneNode(true));
      stage.querySelectorAll('a').forEach(el=>{if(el.getAttribute('href')===url(best)||alt&&el.getAttribute('href')===url(alt))el.addEventListener('click',()=>{const item=el.getAttribute('href')===url(best)?best:alt;track('cookware_finder_product_click',{recommendation:item===best?'primary':'alternative',product_id:item.product.id,variant_id:item.variant.id,material:item.product.material});});});
      track('cookware_finder_complete',{material:p.material,product_id:p.id,variant_id:v.id,shopping_format:a.format,budget:a.budget});focus();scroll();
    }
    function advance(){
      if(editing){
        if(!kitchenComplete()){index=3;renderQuestion();return;}
        if(!a.budget){index=4;renderQuestion();return;}
        renderResult();return;
      }
      index++;if(index===5)renderResult();else renderQuestion();
    }
    stage.addEventListener('click',e=>{
      const answer=e.target.closest('[data-finder-answer]'),edit=e.target.closest('[data-finder-edit]');
      if(answer){const key=keys[index];a[key]=answer.dataset.finderAnswer;track('cookware_finder_answer',{question:index+1,question_key:key,answer:a[key]});if(key==='format'){delete a.budget;if(a.format!=='single')delete a.people;}advance();}
      if(edit){editing=true;index=keys.indexOf(edit.dataset.finderEdit);renderQuestion();scroll();}
      if(e.target.closest('[data-finder-back]')){index=Math.max(0,index-1);renderQuestion();}
      if(e.target.closest('[data-finder-browse]')){root.classList.remove('is-active');root.querySelector('#finder-styles').scrollIntoView({block:'start'});}
    });
    stage.addEventListener('change',e=>{if(e.target.matches('[data-finder-kitchen] select'))revealKitchen();});
    stage.addEventListener('submit',e=>{if(!e.target.matches('[data-finder-kitchen]'))return;e.preventDefault();const fd=new FormData(e.target);for(const [key,value]of fd)a[key]=value;if(!needsSeason())a.season='no';track('cookware_finder_answer',{question:4,question_key:'kitchen',household:a.people||'set',cooktop:a.stove,oven:a.oven,seasoning:a.season});advance();});
    function start(){a={};index=0;editing=false;renderQuestion();scroll();track('cookware_finder_start');}
    root.querySelector('[data-finder-start]').addEventListener('click',start);root.querySelector('[data-finder-reset]').addEventListener('click',start);
  }
  document.querySelectorAll('[data-alva-finder]').forEach(init);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-alva-finder]').forEach(init));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alva-material-report-list"] && !Shopify.designMode) return;
  try {
    if (!window.alvaReportDownloadsReady) {
 window.alvaReportDownloadsReady = true;
 document.addEventListener('click', async event => {
  const button = event.target.closest('[data-report-download]');
  if (!button || button.disabled) return;
  const label = button.textContent;
  const status = button.nextElementSibling;
  button.disabled = true;
  button.textContent = button.dataset.loading;
  status.textContent = '';
  try {
   const response = await fetch(button.dataset.reportDownload, {signal: AbortSignal.timeout(30000)});
   if (!response.ok) throw new Error('Download failed');
   const blob = await response.blob();
   const url = URL.createObjectURL(blob);
   const link = document.createElement('a');
   link.href = url;
   link.download = new URL(button.dataset.reportDownload).pathname.split('/').pop();
   document.body.append(link);
   link.click();
   link.remove();
   setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch {
   status.textContent = button.dataset.error;
  } finally {
   button.disabled = false;
   button.textContent = label;
  }
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alva-material-testing-modal"] && !Shopify.designMode) return;
  try {
    if (!window.__alvaMaterialDialogDismiss) {
    window.__alvaMaterialDialogDismiss = true;
    document.addEventListener('click', event => {
      const dialog = event.target instanceof HTMLDialogElement ? event.target : null;
      if (!dialog || !dialog.matches('[data-alva-material-dialog]') || !dialog.open) return;
      const bounds = dialog.getBoundingClientRect();
      const isOutside = event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom;
      if (isOutside) dialog.close();
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alva-pdp-assurance"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('alva-shipping-threshold')) {
    const instances = new Set();

    document.addEventListener('variant:change', event => {
      const variant = event.detail && event.detail.variant;
      if (!variant || !Number.isFinite(variant.price)) return;

      instances.forEach(element => {
        const section = element.closest('.shopify-section');
        if (section && event.target instanceof Element && section.contains(event.target)) {
          element.dataset.itemPrice = variant.price;
          element.update();
        }
      });
    });

    customElements.define('alva-shipping-threshold', class extends HTMLElement {
      connectedCallback() {
        instances.add(this);
        this.update();
      }

      disconnectedCallback() {
        instances.delete(this);
      }

      update() {
        this.hidden = Number(this.dataset.itemPrice) >= 9900;
      }
    });
  }

  if (!customElements.get('alva-product-shipping-benefit')) {
    customElements.define('alva-product-shipping-benefit', class extends HTMLElement {
      connectedCallback() {
        this.onVariantChange = event => {
          const variant = event.detail && event.detail.variant;
          const section = this.closest('.shopify-section');
          if (!variant || !Number.isFinite(variant.price) || !section || !(event.target instanceof Element) || !section.contains(event.target)) return;
          this.dataset.itemPrice = variant.price;
          this.update();
        };
        document.addEventListener('variant:change', this.onVariantChange);
        this.update();
      }
      disconnectedCallback() {
        document.removeEventListener('variant:change', this.onVariantChange);
      }
      update() {
        const label = this.querySelector('[data-shipping-label]');
        const price = Number(this.dataset.itemPrice);
        const threshold = Number(this.dataset.threshold);
        if (!label || !Number.isFinite(price) || !Number.isFinite(threshold)) return;
        const suffix = price >= threshold ? '' : ' ' + this.dataset.thresholdLabel;
        if (this.dataset.freeLabel === 'Free shipping') {
          const first = document.createElement('span');
          const second = document.createElement('span');
          first.className = second.className = 'alva-reassurance__line';
          first.textContent = 'Free';
          second.textContent = 'shipping' + suffix;
          label.replaceChildren(first, document.createTextNode(' '), second);
        } else {
          label.textContent = this.dataset.freeLabel + suffix;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alva-pdp-purchase-guide"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
  var summary = event.target.closest('.alva-purchase-guide__details--specs > summary');
  if (!summary) return;
  event.preventDefault();
  event.stopPropagation();
  var details = summary.parentElement;
  details.open = !details.open;
  summary.setAttribute('aria-expanded', String(details.open));
}, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alva-product-size-summary"] && !Shopify.designMode) return;
  try {
    if (!window.alvaSizeSummaryReady) {
 window.alvaSizeSummaryReady = true;
 document.addEventListener('variant:change', event => {
  const variant = event.detail && event.detail.variant;
  if (!variant) return;
  const section = event.target.closest && event.target.closest('.shopify-section--main-product');
  if (!section) return;
  section.querySelectorAll('[data-variant-dimensions]').forEach(item => {
   item.hidden = item.dataset.variantDimensions !== String(variant.id);
  });
 });
}
  } catch(e) { console.error(e); }
})();

})();
